var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCategory3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 60,
    viewBox: "0 0 64 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0052 9.36237V4.80797C37.0052 3.26701 38.2383 2 39.738 2H44.1704C45.6701 2 46.9032 3.26701 46.9032 4.80797V9.36237",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9707 17.8548C45.0628 17.8548 47.5695 15.2792 47.5695 12.1019C47.5695 8.92467 45.0628 6.349 41.9707 6.349C38.8785 6.349 36.3718 8.92467 36.3718 12.1019C36.3718 15.2792 38.8785 17.8548 41.9707 17.8548Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67757 30.5249C12.7697 30.5249 15.2764 27.9492 15.2764 24.772C15.2764 21.5947 12.7697 19.019 9.67757 19.019C6.58541 19.019 4.07873 21.5947 4.07873 24.772C4.07873 27.9492 6.58541 30.5249 9.67757 30.5249Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1051 13.4031H46.7698C47.0697 13.4031 47.2364 13.7113 47.1031 13.9852L46.0033 16.0741L43.8371 17.5123H40.0712L37.6384 15.7659L36.7719 13.9852C36.6386 13.7113 36.8385 13.4031 37.1051 13.4031Z",
    fill: "#48CAE4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8402 49.5986C28.0737 49.5986 27.3072 49.3246 26.7073 48.8452L8.24446 34.2232C6.67812 32.9562 4.3786 33.2644 3.14552 34.9081L2.7456 35.4217C1.54585 37.0312 1.81246 39.394 3.41213 40.661L23.6746 56.687C24.5078 57.3718 25.5409 57.7143 26.6073 57.7143H58.0341C59.1339 57.7143 60.1004 57.2691 60.8335 56.5157C61.5334 55.7966 62 54.7693 62 53.6393C62 51.4135 60.2337 49.5643 58.0341 49.5643H28.8402V49.5986Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1403 49.0166C27.4402 49.2563 27.8401 49.3932 28.24 49.3932L37.9713 49.5987C38.5379 49.5987 39.1044 49.4617 39.6043 49.222L45.1032 46.551C45.9364 46.1401 46.9028 46.0374 47.8026 46.3113L58.6004 49.2905C59.6668 49.5987 60.7999 49.1193 61.3665 48.1262C62.133 46.7907 61.5664 45.0785 60.1667 44.4964L47.0028 38.8805C45.9364 38.4353 44.7699 38.4353 43.7035 38.8462L36.405 41.7569C36.1717 41.8597 35.9051 41.8939 35.6718 41.8939H29.8064C29.1732 41.8939 28.54 41.6884 28.0401 41.2775L17.9755 33.333C17.3756 32.8536 16.6424 32.6139 15.9093 32.6139C14.9095 32.6139 13.9097 33.0933 13.2432 33.9494C12.1101 35.4561 12.3767 37.6134 13.843 38.7777L27.1403 49.0166Z",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4082 36.004L33.5723 23.3339C34.5055 22.3409 35.8052 21.793 37.1716 21.793H47.0362C48.3693 21.793 49.669 22.3409 50.6355 23.3339L59.1004 32.1688C59.8336 32.9221 59.9669 34.1206 59.4003 35.011L54.9013 42.2021",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0027 29.9772L50.6694 32.9221C51.3694 33.6755 51.436 34.8398 50.8694 35.6959L48.3694 39.4284",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3071 39.8735L34.5054 31.0729C34.872 30.6962 35.5052 30.9359 35.5052 31.4838V41.8939",
    stroke: "#48CAE4",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory3);
export default __webpack_public_path__ + "static/media/category3.0a056e28c6877557c0a3c7dcb55ddf8a.svg";
export { ForwardRef as ReactComponent };